// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionContentProductServiceV2_container__4e8s2"};